/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FetchExpertsResponseDto } from '../models/FetchExpertsResponseDto';
import type { GetExpertResponseDto } from '../models/GetExpertResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertsService {
    /**
     * Get current expert subscriptions
     * Returns all expert subscriptions for the authenticated expert.
     * @returns any List of expert subscriptions.
     * @throws ApiError
     */
    public static expertsControllerGetMeV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experts/me',
        });
    }
    /**
     * Get expert subscription history
     * Returns subscription event history (RevenueCat webhook events) for the authenticated expert.
     * @returns any List of subscription history events.
     * @throws ApiError
     */
    public static expertsControllerGetSubscriptionsHistoryV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experts/subscriptions/history',
        });
    }
    /**
     * Fetch experts with filters and pagination
     *
     * Retrieves a paginated list of experts.
     *
     * **Search**: Searches by expert ID (EX-XX format), name, or email.
     *
     * **Filters** (comma-separated values):
     * - serviceType: Service type slugs (e.g., personal_trainer,yoga_instructor)
     * - accountStatus: Account statuses (active, inactive, suspended)
     * - verificationStatus: Verification statuses (pending, in_progress, verified, rejected, resubmission_required)
     * - location: City/state names (e.g., delhi,mumbai)
     * - rating: Rating ranges (e.g., 3-4,4-5)
     * - fastTrackVerification: use "true" to return only experts with fast track verification enabled
     *
     * **Distance**: Uses the authenticated client's primary saved location to filter experts within each expert's service_radius_km and sort by distance.
     *
     * **Pagination**: page (default: 1), pageSize (default: 10, max: 100)
     *
     * @param search Search by expert ID (prefix match on EX-XX), name, or email
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @param serviceType Filter by service types (comma-separated slugs)
     * @param accountStatus Filter by account status (comma-separated: active, inactive, suspended)
     * @param verificationStatus Filter by verification status (comma-separated: pending, in_progress, verified, rejected, resubmission_required)
     * @param location Filter by location (comma-separated city/state names)
     * @param rating Filter by rating ranges (comma-separated)
     * @param fastTrackVerification Filter by fast track verification: use "true" to return only experts with is_fasttrack_verification = true
     * @returns FetchExpertsResponseDto Experts fetched successfully
     * @throws ApiError
     */
    public static expertsControllerFetchExpertsV1(
        search?: string,
        page: number = 1,
        pageSize: number = 10,
        serviceType?: string,
        accountStatus?: string,
        verificationStatus?: string,
        location?: string,
        rating?: string,
        fastTrackVerification?: string,
    ): CancelablePromise<FetchExpertsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experts',
            query: {
                'search': search,
                'page': page,
                'pageSize': pageSize,
                'serviceType': serviceType,
                'accountStatus': accountStatus,
                'verificationStatus': verificationStatus,
                'location': location,
                'rating': rating,
                'fastTrackVerification': fastTrackVerification,
            },
        });
    }
    /**
     * Get expert by ID
     *
     * Retrieves detailed information about a single expert.
     *
     * This is a public endpoint.
     * If a valid client bearer token is sent, response includes client-context review flags.
     * If token is missing or invalid, request continues as guest.
     *
     * **ID Format**: Accepts either:
     * - Display ID format: EX-01, EX-02, etc.
     * - UUID format: 550e8400-e29b-41d4-a716-446655440000
     *
     * **Review Flags:**
     * - canReview: true when authenticated client has at least one completed session with expert and has not submitted a review
     * - reviewSubmitted: true when authenticated client already submitted a review for this expert
     *
     * Returns complete expert profile including:
     * - Basic info (name, email, phone, gender, DOB)
     * - Professional info (bio, experience, education, badge level)
     * - Session settings (duration, buffer time, max sessions)
     * - Verification status and notes
     * - Statistics (rating, sessions, clients)
     * - Services offered
     * - Service areas
     * - Uploaded documents
     * - Gallery images
     *
     * @param id Expert ID (display format EX-XX or UUID)
     * @returns GetExpertResponseDto Expert fetched successfully
     * @throws ApiError
     */
    public static expertsControllerGetExpertByIdV1(
        id: string,
    ): CancelablePromise<GetExpertResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/experts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid expert ID format`,
                404: `Expert not found`,
            },
        });
    }
}
